import Button from '../../../../components/button';
import CustomRadio from '../../../../components/mazraeKit/customRadio';
import {PaymentMethodValues} from '../../../shopping-basket/cash-payment/utils/helpers';

const formatAmount = (amount: number) =>
  `${amount.toLocaleString('fa-IR')} تومان`;

interface IProps {
  totalCashBackActiveCredit: number;
  totalBalanceCredit: number;
  value: PaymentMethodValues | undefined;
  isLoading?: boolean;
  onChange: (paymentType: PaymentMethodValues) => void;
  onConfirm: () => void;
}

const CreditTypeStep = ({
  totalCashBackActiveCredit,
  totalBalanceCredit,
  value,
  isLoading = false,
  onChange,
  onConfirm,
}: IProps) => (
  <div className="flex flex-col w-full gap-8 py-2">
    <p className="w-full p-0 m-0 text-sm font-medium text-center text-gray-950">
      انتخاب اعتبار
    </p>

    <p className="p-0 m-0 text-sm text-gray-500">
      پرداخت با کدام اعتبار انجام شود؟
    </p>

    <div className="flex flex-col">
      {totalCashBackActiveCredit > 0 && (
        <CreditOption
          radioValue="cash-back"
          title="اعتبار بازگشتی"
          amountLabel="اعتبار فعال"
          amount={totalCashBackActiveCredit}
          selected={value === PaymentMethodValues.CASHBACK_PAYMENT}
          disabled={isLoading}
          onSelect={() => onChange(PaymentMethodValues.CASHBACK_PAYMENT)}
        />
      )}
      {totalBalanceCredit > 0 && (
        <CreditOption
          radioValue="credit"
          title="اعتبار"
          amountLabel="موجودی اعتبار"
          amount={totalBalanceCredit}
          selected={value === PaymentMethodValues.CREDIT_PAYMENT}
          disabled={isLoading}
          onSelect={() => onChange(PaymentMethodValues.CREDIT_PAYMENT)}
        />
      )}
      {/* // TODO : ADD BNPL */}
      {/* {totalBNPLCredit > 0 && (
        <CreditOption
          radioValue="credit"
          title="اعتبار BNPL"
          amountLabel="موجودی اعتبار"
          amount={totalBNPLCredit}
          selected={value === PaymentMethodValues.BNPL_PAYMENT}
          disabled={isLoading}
          onSelect={() => onChange(PaymentMethodValues.BNPL_PAYMENT)}
        />
      )} */}
    </div>

    <Button disabled={isLoading || !value} onClick={onConfirm}>
      تایید و ادامه
    </Button>
  </div>
);

export default CreditTypeStep;

// ---------------------------------------------------------

interface ICreditOptionProps {
  radioValue: string;
  title: string;
  amountLabel: string;
  amount: number;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
}

const CreditOption = ({
  radioValue,
  title,
  amountLabel,
  amount,
  selected,
  disabled,
  onSelect,
}: ICreditOptionProps) => (
  <div
    className="flex items-start w-full gap-3 py-4 border-b border-gray-100"
    onClick={() => {
      if (!disabled) onSelect();
    }}
  >
    <CustomRadio
      name="credit-pay-method"
      title=""
      value={radioValue}
      checked={selected}
      disabled={disabled}
      onChange={onSelect}
      customClassName="text-sm text-gray-800"
      inputClassname="size-4"
    />

    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <i className="text-xl text-gray-800 icon-nameWallet-income" />
        <span className="text-sm font-medium text-gray-900">{title}</span>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">{amountLabel}</span>
        <span className="font-medium text-gray-700 text-md">
          {formatAmount(amount)}
        </span>
      </div>
    </div>
  </div>
);
